import {
  AutocompleteInput,
  NumberInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import parserFormatNumInput from "../../../utils/parserFormatNumInput";

const customerFilterList = (permissions) => {
  const defaultFilter = [
    // <TextInput
    //   source="all"
    //   label="mine.filter.search_all"
    //   alwaysOn
    //   resettable
    //   variant="outlined"
    //   InputProps={{
    //     endAdornment: (
    //       <InputAdornment position="end">
    //         <SearchIcon />
    //       </InputAdornment>
    //     ),
    //   }}
    // />,
    <TextInput
      alwaysOn
      source="name"
      label="mine.label.name"
      resettable
      variant="outlined"
    />,
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.code"
      resettable
      variant="outlined"
    />,
    <TextInput
      alwaysOn
      source="pic"
      label="mine.label.pic"
      resettable
      variant="outlined"
    />,
    <TextInput
      alwaysOn
      source="loan_limit"
      label="mine.label.loan_limit"
      resettable
      variant="outlined"
      InputProps={{
        startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
        // endAdornment: <InputAdornment position="end">/Box</InputAdornment>,
      }}
      {...parserFormatNumInput}
    />,
    <NumberInput
      alwaysOn
      source="loan_tenor"
      label="mine.label.loan_tenor"
      resettable
      variant="outlined"
    />,
    <NumberInput
      alwaysOn
      source="loan_tenor_tolerance"
      label="mine.label.loan_tenor_tolerance"
      resettable
      variant="outlined"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default customerFilterList;
